var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatIconHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 29.8005C23.3612 29.8005 29.3307 23.8309 29.3307 16.4671C29.3307 9.10333 23.3612 3.13379 15.9974 3.13379C8.6336 3.13379 2.66406 9.10333 2.66406 16.4671C2.66406 23.8309 8.6336 29.8005 15.9974 29.8005Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6615 14.986C22.6615 14.7895 22.5834 14.6011 22.4445 14.4622C22.3056 14.3233 22.1172 14.2452 21.9207 14.2452H18.217V10.5415C18.217 10.3451 18.139 10.1567 18.0001 10.0177C17.8611 9.87882 17.6727 9.80078 17.4763 9.80078H14.5133C14.3169 9.80078 14.1284 9.87882 13.9895 10.0177C13.8506 10.1567 13.7726 10.3451 13.7726 10.5415V14.2452H10.0689C9.87241 14.2452 9.684 14.3233 9.54508 14.4622C9.40617 14.6011 9.32812 14.7895 9.32812 14.986V17.9489C9.32812 18.1454 9.40617 18.3338 9.54508 18.4727C9.684 18.6116 9.87241 18.6897 10.0689 18.6897H13.7726V22.3934C13.7726 22.5898 13.8506 22.7782 13.9895 22.9172C14.1284 23.0561 14.3169 23.1341 14.5133 23.1341H17.4763C17.6727 23.1341 17.8611 23.0561 18.0001 22.9172C18.139 22.7782 18.217 22.5898 18.217 22.3934V18.6897H21.9207C22.1172 18.6897 22.3056 18.6116 22.4445 18.4727C22.5834 18.3338 22.6615 18.1454 22.6615 17.9489V14.986Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatIconHealth);
export default __webpack_public_path__ + "static/media/gat-icon-health.ae56422fd8ca2c05d69842b091bcf6c9.svg";
export { ForwardRef as ReactComponent };